import React, { Component, Fragment } from 'react';
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import TextField from '../form/TextField';
import Checkbox from '../form/Checkbox';
import Grid from '../layout/Grid';
import Inline, { inlineAlignment } from '../layout/Inline';
import Button from '../form/Button';
import DeleteIcon from '../icon/DeleteIcon';
import Select from '../form/Select';
import {
    ApplicantOption,
    AshesCollectedByOptions,
    DispatchMethodOptions,
    FuneralDirectorOption,
    InternalDisposal
} from '../ComponentConstants';
import AddressAutocomplete, { createAddressComponentFields } from '../form/AddressAutocomplete';
import { joinDefined, numberToWords } from '../../utils/strings';
import StaffAutoComplete from '../form/StaffAutoComplete';
import UserCircle from '../form/UserCircle';
import Label from '../form/Label';
import AlertModal from './AlertModal';
import { CONTAINMENT_STYLE } from '../../constants/Dispatch';
import { deleteTypeName, isNullOrUndefined } from '../../utils/objects';
import Modal from './Modal';
import Table, { Cell, Row } from '../table/Table';
import { EditIcon } from '../IconIndex';
import { shortDateTimeFromString } from '../../utils/date';
import Typography from '../form/Typography';
import AlertBar from '../form/AlertBar';

class Dispatch extends Component {
    state = {
        dispatchDateToDelete: null,
        showDeleteDispatchDateAlertModal: false,
        isCustomDeliveryAddressModel: false,
        showAddDispatchModal: false,
        dispatchIndex: null
    };

    handleCloseDeleteDispatchDateModal() {
        this.setState({ dispatchDateToDelete: null });
        this.setState({ showDeleteDispatchDateAlertModal: false });
    }

    handleShowDeleteDispatchDateModal(dispatchDate) {
        this.setState({ dispatchDateToDelete: dispatchDate });
        this.setState({ showDeleteDispatchDateAlertModal: true });
    }

    handleDeleteDispatchDate() {
        const { form } = this.props;
        const DispatchDates = form.getState('DispatchDates') || [];

        let dispatchDate = this.state.dispatchDateToDelete;

        let dispatchDateIndex = DispatchDates.indexOf(dispatchDate);
        if (dispatchDateIndex !== -1) {
            DispatchDates.splice(dispatchDateIndex, 1);
            form.setState({ DispatchDates });
        }

        this.setState({ dispatchDateToDelete: null });
        this.setState({ showDeleteDispatchDateAlertModal: false });
    }

    handleSelectStaff(propertyName, staff) {
        const { form } = this.props;
        if (!!staff) {
            delete staff['__typename'];
            const staffList = form.getState(propertyName) || [];
            const idx = staffList.findIndex(person => person.ID === staff.ID);
            if (idx < 0) {
                staffList.push(staff);
                form.setState({ [propertyName]: staffList });
            }
        }
    }

    handleDeleteStaff(propertyName, staff) {
        const { form } = this.props;
        const staffList = form.getState(propertyName) || [];
        const idx = staffList.findIndex(person => person.ID === staff.ID);
        if (idx < 0) {
            // huh?
        } else {
            staffList.splice(idx, 1);
            form.setState({ [propertyName]: staffList });
        }
    }

    handleAddDispatchDate() {
        const { form } = this.props;
        const DispatchDates = form.getState('DispatchDates') || [];
        DispatchDates.push({});
        form.setState({ DispatchDates });
        this.setState({ showAddDispatchModal: true, dispatchIndex: DispatchDates.length - 1 });
    }

    handleSelectBusinessContact(propertyName, addressBook) {
        const { form } = this.props;

        if (!!addressBook) {
            deleteTypeName(addressBook);
            form.setState({ [propertyName]: addressBook });
        } else {
            form.setState({ [propertyName]: null });
        }
    }

    handleAddressString(addr) {
        if (!addr) {
            return '';
        }
        return joinDefined(
            [
                addr.Name,
                addr.AddressLine1,
                addr.AddressLine2,
                joinDefined(
                    [addr.Suburb, addr.State, addr.Postcode, addr.Country !== 'Australia' ? addr.Country : null],
                    ' '
                )
            ],
            ', '
        );
    }

    renderDestinationAddressField(index) {
        const { form } = this.props;
        const { isCustomDeliveryAddressModel } = this.state;

        const dispatchDates = form.getState('DispatchDates') || [];
        const dispatchDate = dispatchDates[index];

        if (!dispatchDate) {
            return <Grid item xs={12} sm={6} />;
        }

        if (!['Delivered to', 'Posted'].includes(dispatchDate.DispatchMethod)) {
            return <Grid item xs={12} sm={6} />;
        }

        const dispatchDateDestinationAddressComponentFields = createAddressComponentFields(
            'DispatchDates[' + index + '].DestinationAddress'
        );

        const fdOptions = [].concat(form.getState('Business.DeliveryAddresses'), [{
            Line1: form.getState('Business.AddressLine1'),
            Line2: form.getState('Business.AddressLine2'),
            Suburb: form.getState('Business.Suburb'),
            State: form.getState('Business.State'),
            Postcode: form.getState('Business.Postcode')
        }]);
        const cleanedFDOptions =
            !!fdOptions &&
            fdOptions.map((o) => {
                return {
                    value: this.handleAddressString(deleteTypeName(o || {})),
                    label: this.handleAddressString(o)
                };
            });
        const applicantResAddr = form.getState('Client.ResidentialAddress');
        const applicantPostAddr = form.getState('Client.PostalAddress');

        const applicantAddrOptions = form.getState('Client.PostalAddressSameAsResidentialAddress')
            ? [applicantResAddr]
            : [applicantPostAddr || applicantResAddr];
        const cleanedApplicantOptions =
            !!applicantAddrOptions &&
            applicantAddrOptions
                .filter(o => o != null)
                .map((o) => {
                    return {
                        value: this.handleAddressString(deleteTypeName(o)),
                        label: this.handleAddressString(o)
                    };
                });

        const isFD = !!form.getState(`DispatchDates[${index}].AshesCollectedBy`) && (form.getState(`DispatchDates[${index}].AshesCollectedBy`) === FuneralDirectorOption);
        const isApplicant = !!form.getState(`DispatchDates[${index}].AshesCollectedBy`) && (form.getState(`DispatchDates[${index}].AshesCollectedBy`) === ApplicantOption);
        const isApplicantBusiness = !!form.getState('ClientSameAsEnquirer');
        const label = 'Posted' === dispatchDate.DispatchMethod ? 'Postal Address' : 'Delivery Address';
        return (
            <Grid item xs={12} sm={6}>
                {(isCustomDeliveryAddressModel || (!isFD && !isApplicant)) ? (
                    <Inline alignment={inlineAlignment.rightAlignSiblings} nowrap center>
                        <AddressAutocomplete
                            allowCustomAddress
                            label={label}
                            placeholder="Search for address..."
                            form={form}
                            componentFields={dispatchDateDestinationAddressComponentFields}
                        />
                        {(
                                (cleanedFDOptions && cleanedFDOptions.length !== 0 && isFD) ||
                                (cleanedApplicantOptions && cleanedApplicantOptions.length !== 0 && isApplicant)) &&
                            <Button
                                variant="orange-link"
                                onClick={() => this.setState({ isCustomDeliveryAddressModel: false })}
                            >
                                Contact Addresses
                            </Button>
                        }
                    </Inline>
                ) : isFD || (isApplicant && isApplicantBusiness) ? (
                    <Inline alignment={inlineAlignment.rightAlignSiblings} nowrap center>
                        <Select
                            label={label}
                            name={`DispatchDates[${index}].DestinationAddress`}
                            value={this.handleAddressString(
                                form.getState(`DispatchDates[${index}].DestinationAddress`)
                            )}
                            form={form}
                            options={cleanedFDOptions}
                            onChange={(e, val) => {
                                const selectedOption = fdOptions.find(
                                    o => this.handleAddressString(deleteTypeName(o)) === val
                                );
                                if (selectedOption) {
                                    form.setState({
                                        [`DispatchDates[${index}].DestinationAddress`]: deleteTypeName(selectedOption)
                                    });
                                }
                            }}
                        />

                        <Button
                            variant="orange-link"
                            onClick={() => this.setState({ isCustomDeliveryAddressModel: true })}
                        >
                            Add&nbsp;new
                        </Button>
                    </Inline>
                ) : isApplicant && !isApplicantBusiness ? (
                    <Fragment>
                        <Inline alignment={inlineAlignment.rightAlignSiblings} nowrap center>
                            <Select
                                label={label}
                                name={`DispatchDates[${index}].DestinationAddress`}
                                value={this.handleAddressString(
                                    form.getState(`DispatchDates[${index}].Destinati &&onAddress`)
                                )}
                                form={form}
                                options={cleanedApplicantOptions}
                                onChange={(e, val) => {
                                    const selectedOption = applicantAddrOptions.find(
                                        o => this.handleAddressString(deleteTypeName(o)) === val
                                    );
                                    if (selectedOption) {
                                        form.setState({
                                            [`DispatchDates[${index}].DestinationAddress`]: deleteTypeName(selectedOption)
                                        });
                                    }
                                }}
                            />

                            <Button
                                variant="orange-link"
                                onClick={() => this.setState({ isCustomDeliveryAddressModel: true })}
                            >
                                Add&nbsp;new
                            </Button>
                        </Inline>
                    </Fragment>
                ) : null}
            </Grid>
        );
    }

    renderDispatchEditor(dispatchDate, index) {
        const { form } = this.props;
        const staffField = `DispatchDates[${index}].AssignedStaff`;
        const assignedStaff = form.getField(staffField);
        const isInternalDisposal = !!form.getField(`DispatchDates[${index}].DispatchMethod`) && form.getField(`DispatchDates[${index}].DispatchMethod`) === InternalDisposal;
        const isExisting = form.getField(`DispatchDates[${index}].ID`) > 0;

        return (
            <Grid key={index} container>
                <Grid item xs={12}>
                    <Typography variant="h4">
                        {isExisting ? 'Update' : 'New'} Dispatch {numberToWords(1 + index)}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Select
                        label="Dispatch Method"
                        options={DispatchMethodOptions}
                        name={`DispatchDates[${index}].DispatchMethod`}
                        form={form}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Checkbox
                        label="Is this dispatch completed?"
                        name={`DispatchDates[${index}].DispatchComplete`}
                        form={form}
                    />
                </Grid>

                {!isInternalDisposal && (
                    <Fragment>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Date" type="date" name={`DispatchDates[${index}].Date`} form={form} />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="Time" type="time" name={`DispatchDates[${index}].Time`} form={form} />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Select
                                label="Vessel on dispatch"
                                options={CONTAINMENT_STYLE}
                                form={form}
                                name={`DispatchDates[${index}].ContainmentStyle`}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Ashes Portion"
                                placeholder="Enter ashes portion"
                                name={`DispatchDates[${index}].Ashes`}
                                form={form}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Select
                                label="Ashes collected by"
                                options={AshesCollectedByOptions}
                                name={`DispatchDates[${index}].AshesCollectedBy`}
                                form={form}
                            />
                        </Grid>

                        {this.renderDestinationAddressField(index)}

                    </Fragment>
                )}
                <Grid item xs={12} sm={6}>
                    <Label htmlFor={staffField + '-input'}>Assigned Staff</Label>
                    {assignedStaff && !!assignedStaff.length ? (
                        <div className="user-container" style={{ margin: '6px 0' }}>
                            {assignedStaff.map(person => (
                                <UserCircle
                                    key={person.ID}
                                    member={person}
                                    onDelete={() => this.handleDeleteStaff(staffField, person)}
                                />
                            ))}
                        </div>
                    ) : <br />}
                    <StaffAutoComplete
                        placeholder="Search for a staff name here"
                        selectProps={{ multiple: true }}
                        name={staffField}
                        onSelect={(_, person) => this.handleSelectStaff(staffField, person)}
                    />
                </Grid>

                <Grid item>
                    <TextField
                        label="Comment"
                        name={`DispatchDates[${index}].Comment`}
                        form={form}
                        multiline
                        button={{
                            variant: 'secondary',
                            children: '+ Add Comments'
                        }}
                    />
                </Grid>
            </Grid>
        );
    }

    handleCellVal(val) {
        if (isNullOrUndefined(val)) {
            return '';
        }
        if (typeof val === 'boolean') {
            return val ? 'Yes' : 'No';
        }
        return val;
    }

    handleAssignedStaffArray(arr) {
        if (!arr || arr.length === 0) {
            return '';
        }
        return (
            joinDefined(
                arr.map(obj => joinDefined([obj.FirstName, obj.Surname], ' ')),
                ', '
            ) || ''
        );
    }

    renderDispatchTables() {
        const { form } = this.props;
        const { showAddDispatchModal, dispatchIndex } = this.state;
        const dispatchDates = form.getState('DispatchDates') || [];

        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Dispatches</h4>
                </Grid>

                {dispatchDates.map((dispatchDate, idx) => {
                    const dispatchMethodOption = DispatchMethodOptions.find((item) => item.value === dispatchDate.DispatchMethod);
                    const isOverdue = !dispatchDate.DispatchComplete && moment(joinDefined([dispatchDate.Date || '', dispatchDate.Time || ''], ' ')).isBefore(moment());
                    return (
                        <Grid key={idx} item xs={12}>
                            <Table className="no-response"
                                   columns={[
                                       {
                                           label: (
                                               <>
                                                   <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                                                       <h5>Dispatch {numberToWords(idx + 1)}: {dispatchMethodOption ? dispatchMethodOption.label : null}</h5>
                                                       <div style={{ display: 'flex', flexWrap: 'nowrap', gap: 0 }}>
                                                           <IconButton
                                                               className="icon"
                                                               title="Edit"
                                                               onClick={() => {
                                                                   this.setState({
                                                                       showAddDispatchModal: true,
                                                                       dispatchIndex: idx
                                                                   });
                                                               }} size="large">
                                                               <EditIcon style={{ color: 'white' }} />
                                                           </IconButton>
                                                           <IconButton
                                                               className="icon"
                                                               title="Delete"
                                                               onClick={() => this.handleShowDeleteDispatchDateModal(dispatchDate)}
                                                               size="large">
                                                               <DeleteIcon style={{ color: 'white' }} />
                                                           </IconButton>
                                                       </div>
                                                   </Inline>
                                               </>
                                           )
                                       }
                                   ]}
                                   columnspans={[2]}
                                   columnHeaders={[1]}
                            >
                                <Row pad={false}>
                                    <Cell colSpan={2}>
                                        <AlertBar
                                            style={{ margin: 0 }}
                                            variant={dispatchDate.DispatchComplete
                                                ? 'success'
                                                : isOverdue
                                                    ? 'warning'
                                                    : 'attention'
                                            }
                                        >
                                            <p>Dispatch {dispatchDate.DispatchComplete ? 'Done.' : isOverdue ? 'OVERDUE!' : 'Pending'}</p>
                                        </AlertBar>
                                    </Cell>
                                </Row>
                                <Row pad>
                                    <Cell><strong>Date & Time</strong></Cell>
                                    <Cell>
                                        {shortDateTimeFromString(
                                            joinDefined([dispatchDate.Date || '', dispatchDate.Time || ''], ' ')
                                        )}
                                    </Cell>
                                </Row>
                                {InternalDisposal === dispatchDate.DispatchMethod ? (
                                    <Row pad>
                                        <Cell><strong>Assigned Staff</strong></Cell>
                                        <Cell>{this.handleAssignedStaffArray(dispatchDate.AssignedStaff)}</Cell>
                                    </Row>
                                ) : (
                                    <>
                                        <Row pad>
                                            <Cell><strong>Collected By</strong></Cell>
                                            <Cell>{this.handleCellVal(dispatchDate.AshesCollectedBy)}</Cell>
                                        </Row>

                                        {!dispatchDate.DispatchComplete && (
                                            <>
                                                <Row pad>
                                                    <Cell><strong>Destination Address</strong></Cell>
                                                    <Cell>{this.handleAddressString(dispatchDate.DestinationAddress)}</Cell>
                                                </Row>

                                                <Row pad>
                                                    <Cell><strong>Containment Style</strong></Cell>
                                                    <Cell>{this.handleCellVal(dispatchDate.ContainmentStyle)}</Cell>
                                                </Row>

                                                <Row pad>
                                                    <Cell><strong>Ashes Portion</strong></Cell>
                                                    <Cell>{this.handleCellVal(dispatchDate.Ashes)}</Cell>
                                                </Row>

                                                <Row pad>
                                                    <Cell><strong>Assigned Staff</strong></Cell>
                                                    <Cell>{this.handleAssignedStaffArray(dispatchDate.AssignedStaff)}</Cell>
                                                </Row>
                                            </>
                                        )}
                                    </>
                                )}
                                {dispatchDate.Comment && (
                                    <Row pad>
                                        <Cell><strong>Comment</strong></Cell>
                                        <Cell>{this.handleCellVal(dispatchDate.Comment)}</Cell>
                                    </Row>
                                )}
                            </Table>
                        </Grid>
                    );
                })}

                <Modal
                    variant="simple"
                    open={showAddDispatchModal}
                    onClose={() => {
                        this.setState({ showAddDispatchModal: false });
                    }}
                    // actions={
                    //     <Button
                    //         variant="primary"
                    //         onClick={() => {
                    //             const { form } = this.props;
                    //             form.save();
                    //             this.setState({ showAddDispatchModal: false });
                    //         }}
                    //     >
                    //         Save
                    //     </Button>
                    // }
                >
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            {dispatchDates.length > 0 &&
                                this.renderDispatchEditor(dispatchDates[dispatchIndex], dispatchIndex)}
                        </Grid>
                    </Grid>
                </Modal>

                <Grid item>
                    <Button variant="primary" onClick={() => this.handleAddDispatchDate()}>
                        Add Dispatch...
                    </Button>
                </Grid>
            </Grid>
        );
    }

    render() {
        const { form } = this.props;
        const { showDeleteDispatchDateAlertModal, dispatchDateToDelete } = this.state;
        const DispatchDates = form.getState('DispatchDates') || [];
        const dispatchIdx = DispatchDates.indexOf(dispatchDateToDelete);
        return (
            <Fragment>
                {this.renderDispatchTables()}
                <AlertModal
                    variant="warning"
                    open={showDeleteDispatchDateAlertModal}
                    title="Prompt"
                    secondaryAction="Yes, Delete"
                    onClickSecondaryAction={() => this.handleDeleteDispatchDate()}
                    primaryAction="Cancel"
                    onClickPrimaryAction={() => this.handleCloseDeleteDispatchDateModal()}
                    onClose={() => this.handleCloseDeleteDispatchDateModal()}
                >
                    <p>You're about to delete dispatch {numberToWords(1 + dispatchIdx)}.</p>
                    <p>Are you sure?</p>
                </AlertModal>
            </Fragment>
        );
    }
}

export default Dispatch;
